const floorplan = {
  floorplan: 'Plano de Planta',
  add_floorplan: 'Nuevo Plano de Planta',
  upload_floorplan: 'Subir Plano de Planta',
  remove_floorplan: 'Eliminar Plano de Planta',
  live_view: 'Vista en vivo',
  live_view_title: 'Plano - Vista en vivo - {{name}}',
  delete_image_msg:
    '¿Estás seguro de que quieres eliminar la imagen del plano de planta?',
  last_activity: 'Últimos Eventos',
  events: 'Eventos',
  no_events: 'SIN EVENTOS',
  disable_credential: 'Deshabilitar Credencial',
  disable_credential_msg:
    '¿Estás seguro de que quieres deshabilitar esta credencial?',
  credential_disabled: 'Credencial Deshabilitada',
  all: 'Todos',
  snap_to_grid_while_dragging: 'Ajustar a la cuadrícula al arrastrar',
  snap_to_grid_after_drop: 'Ajustar a la cuadrícula al soltar',
  form: {
    available_allusers: 'Disponible para todos los usuarios',
    small_icons: 'Iconos pequeños',
    doors: 'Puertas',
  },
};

export default floorplan;
